function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getYear, addYears, setYear } from 'date-fns';
import YearTable from './yearTable.js';
var __vue_script__ = {
  name: 'YearPanel',
  components: {
    YearTable: YearTable
  },
  props: {
    rootPrefixCls: String,
    locale: Object,
    value: Date,
    disabledYear: {
      type: Function,
      default: undefined
    },
    yearNav: {
      type: Object,
      default: function _default() {
        return {
          prev: true,
          next: true
        };
      }
    }
  },
  data: function data() {
    return {
      innerValue: this.value
    };
  },
  computed: {
    prefixCls: function prefixCls() {
      var rootPrefixCls = this.rootPrefixCls;
      return "".concat(rootPrefixCls, "-year-panel");
    },
    classes: function classes() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, prefixCls, true);
    },
    currentYear: function currentYear() {
      var innerValue = this.innerValue;
      return getYear(innerValue);
    },
    startYear: function startYear() {
      var currentYear = this.currentYear;
      return Math.floor(currentYear / 10) * 10;
    },
    endYear: function endYear() {
      var startYear = this.startYear;
      return startYear + 9;
    }
  },
  watch: {
    value: function value(nVal) {
      this.setInnerValue(nVal, false);
    }
  },
  methods: {
    setInnerValue: function setInnerValue(value) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.innerValue = value;

      if (trigger) {
        this.$emit('on-change', value);
      }
    },
    goYear: function goYear(direction) {
      var nYear = addYears(this.innerValue, direction);
      this.setInnerValue(nYear);
    },
    prevDecade: function prevDecade() {
      this.goYear(-10);
    },
    nextDecade: function nextDecade() {
      this.goYear(10);
    },
    showDecadePanel: function showDecadePanel() {
      this.$emit('on-show-decade-panel');
    },
    onSelect: function onSelect(value) {
      var originVal = this.value,
          startYear = this.startYear,
          endYear = this.endYear,
          setInnerValue = this.setInnerValue;

      if (value < startYear) {
        this.prevDecade();
      } else if (value > endYear) {
        this.nextDecade();
      } else {
        var year = setYear(originVal, value);
        setInnerValue(year);
        this.$emit('on-select', year);
      }
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    class: _vm.prefixCls + "-header"
  }, [_c('a', {
    class: _vm.prefixCls + "-prev-decade-btn",
    attrs: {
      "title": _vm.locale.previousDecade,
      "role": "button"
    },
    on: {
      "click": _vm.prevDecade
    }
  }), _vm._v(" "), _c('a', {
    class: _vm.prefixCls + "-decade-select",
    on: {
      "click": _vm.showDecadePanel
    }
  }, [_c('span', {
    class: _vm.prefixCls + "-decade-select-content"
  }, [_vm._v("\n        " + _vm._s(_vm.startYear) + "-" + _vm._s(_vm.endYear) + "\n      ")])]), _vm._v(" "), _c('a', {
    class: _vm.prefixCls + "-next-decade-btn",
    attrs: {
      "title": _vm.locale.nextDecade,
      "role": "button"
    },
    on: {
      "click": _vm.nextDecade
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.prefixCls + "-body"
  }, [_c('year-table', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "value": _vm.currentYear,
      "start": _vm.startYear,
      "end": _vm.endYear,
      "locale": _vm.locale,
      "disabled-year": _vm.disabledYear
    },
    on: {
      "on-select": _vm.onSelect
    }
  })], 1)]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "yearPanel.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);